/* eslint-disable */
/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * MARKETview API
 * OpenAPI spec version: 0.0.1
 */
import { useMutation } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';

import type {
  AidModelResultsResponseDto,
  NonModeledAdjustmentActionDto,
  NonModeledAdjustmentDto,
  NonModeledAdjustmentRequestDto,
} from '../schemas';

import { customAxios } from '../../orval-mutator';
import type { ErrorType, BodyType } from '../../orval-mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_FD_PRINCIPAL, ROLE_FD_ANALYST, ROLE_REPORT_ADMIN, ROLE_USER, ROLE_INTERNAL_USER**<br /><br />Applies a batch of SAVE (upsert) and RESET actions on the persisted non-modeled adjustments for this model. RESET deletes the row unless repackageWithNewRegimes is set on it, in which case only the two manual overrides are cleared and the row (and toggle) survive. Returns the full current persisted set after all actions are applied.
 * @summary Persist non-modeled adjustments
 */
export const saveNonModeledAdjustments = (
  oktaUserId: string,
  modelId: number,
  nonModeledAdjustmentActionDto: BodyType<NonModeledAdjustmentActionDto[]>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<NonModeledAdjustmentDto[]>(
    {
      url: `/api/${oktaUserId}/aid-models/${modelId}/adjustments/non-modeled`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: nonModeledAdjustmentActionDto,
      signal,
    },
    options
  );
};

export const getSaveNonModeledAdjustmentsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveNonModeledAdjustments>>,
    TError,
    {
      oktaUserId: string;
      modelId: number;
      data: BodyType<NonModeledAdjustmentActionDto[]>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof saveNonModeledAdjustments>>,
  TError,
  {
    oktaUserId: string;
    modelId: number;
    data: BodyType<NonModeledAdjustmentActionDto[]>;
  },
  TContext
> => {
  const mutationKey = ['saveNonModeledAdjustments'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof saveNonModeledAdjustments>>,
    {
      oktaUserId: string;
      modelId: number;
      data: BodyType<NonModeledAdjustmentActionDto[]>;
    }
  > = (props) => {
    const { oktaUserId, modelId, data } = props ?? {};

    return saveNonModeledAdjustments(oktaUserId, modelId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SaveNonModeledAdjustmentsMutationResult = NonNullable<
  Awaited<ReturnType<typeof saveNonModeledAdjustments>>
>;
export type SaveNonModeledAdjustmentsMutationBody = BodyType<
  NonModeledAdjustmentActionDto[]
>;
export type SaveNonModeledAdjustmentsMutationError = ErrorType<unknown>;

/**
 * @summary Persist non-modeled adjustments
 */
export const useSaveNonModeledAdjustments = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof saveNonModeledAdjustments>>,
      TError,
      {
        oktaUserId: string;
        modelId: number;
        data: BodyType<NonModeledAdjustmentActionDto[]>;
      },
      TContext
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof saveNonModeledAdjustments>>,
  TError,
  {
    oktaUserId: string;
    modelId: number;
    data: BodyType<NonModeledAdjustmentActionDto[]>;
  },
  TContext
> => {
  return useMutation(
    getSaveNonModeledAdjustmentsMutationOptions(options),
    queryClient
  );
};
/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_FD_PRINCIPAL, ROLE_FD_ANALYST, ROLE_REPORT_ADMIN, ROLE_USER, ROLE_INTERNAL_USER**<br /><br />Computes and returns the recalculated Aid Results estimated band with the previewed adjustment stacked on top of any persisted adjustments for this model. The same key replaces the persisted entry; a new key is appended. This is a read-only computation — nothing is persisted.
 * @summary Preview a non-modeled adjustment
 */
export const previewNonModeledAdjustment = (
  oktaUserId: string,
  modelId: number,
  nonModeledAdjustmentRequestDto: BodyType<NonModeledAdjustmentRequestDto>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<AidModelResultsResponseDto>(
    {
      url: `/api/${oktaUserId}/aid-models/${modelId}/adjustments/non-modeled/preview`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: nonModeledAdjustmentRequestDto,
      signal,
    },
    options
  );
};

export const getPreviewNonModeledAdjustmentMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof previewNonModeledAdjustment>>,
    TError,
    {
      oktaUserId: string;
      modelId: number;
      data: BodyType<NonModeledAdjustmentRequestDto>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof previewNonModeledAdjustment>>,
  TError,
  {
    oktaUserId: string;
    modelId: number;
    data: BodyType<NonModeledAdjustmentRequestDto>;
  },
  TContext
> => {
  const mutationKey = ['previewNonModeledAdjustment'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof previewNonModeledAdjustment>>,
    {
      oktaUserId: string;
      modelId: number;
      data: BodyType<NonModeledAdjustmentRequestDto>;
    }
  > = (props) => {
    const { oktaUserId, modelId, data } = props ?? {};

    return previewNonModeledAdjustment(
      oktaUserId,
      modelId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PreviewNonModeledAdjustmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof previewNonModeledAdjustment>>
>;
export type PreviewNonModeledAdjustmentMutationBody =
  BodyType<NonModeledAdjustmentRequestDto>;
export type PreviewNonModeledAdjustmentMutationError = ErrorType<unknown>;

/**
 * @summary Preview a non-modeled adjustment
 */
export const usePreviewNonModeledAdjustment = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof previewNonModeledAdjustment>>,
      TError,
      {
        oktaUserId: string;
        modelId: number;
        data: BodyType<NonModeledAdjustmentRequestDto>;
      },
      TContext
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof previewNonModeledAdjustment>>,
  TError,
  {
    oktaUserId: string;
    modelId: number;
    data: BodyType<NonModeledAdjustmentRequestDto>;
  },
  TContext
> => {
  return useMutation(
    getPreviewNonModeledAdjustmentMutationOptions(options),
    queryClient
  );
};
